import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useResizeObserver } from '@vueuse/core';
import { CSSProperties, nextTick, onMounted, ref, watch } from 'vue';
import DownArrowIcon from './icons/navigation/DownArrowIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VCollapse',
  props: {
    title: null,
    opened: { type: Boolean },
    lazyAnimation: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as { title?: string, opened?: boolean, lazyAnimation?: boolean }



const opened = ref(props.opened ?? false)
const style = ref<CSSProperties>({ display: "none" })
const innerRef = ref<HTMLElement>()

useResizeObserver(innerRef, () => {
  if (!opened.value || props.lazyAnimation) return
  calc()
})

const calc = async () => {
  if (opened.value) {
    style.value = { display: "block", height: "0px" }
    await nextTick()
    if (!opened.value) return
    style.value = { height: innerRef.value!.clientHeight+"px" }
  } else {
    if (props.lazyAnimation) {
      style.value = { height: innerRef.value!.clientHeight+"px" }
      await new Promise(res => requestAnimationFrame(res))
    }
    style.value = { height: "0px" }
    setTimeout(() => {
      if (opened.value) return
      style.value = { display: "none", height: "0px" }
    }, 220)
  }
}

if (props.opened) {
  style.value = { display: "block", height: "auto", transition: "none" }
}

let timeout: ReturnType<typeof setTimeout>
watch(opened, () => {
  calc()
  if (opened.value && props.lazyAnimation) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      style.value.height = "auto"
      style.value.transition = "none"
    }, 300)
  }
})

const onHeaderClick = (e: MouseEvent) => {
  e.preventDefault()
  e.stopPropagation()
  opened.value = !opened.value
}

expose({
  open() {
    opened.value = true
  },
  close() {
    opened.value = false
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-collapse", { opened: opened.value }])
  }, [
    _renderSlot(_ctx.$slots, "activator", {
      opened: opened.value,
      toggle: onHeaderClick
    }, () => [
      _createElementVNode("button", {
        class: "v-collapse__header",
        onClick: onHeaderClick
      }, [
        _createTextVNode(_toDisplayString(props.title) + " ", 1),
        _createVNode(DownArrowIcon, { class: "down-arrow-icon" })
      ])
    ]),
    _createElementVNode("div", {
      class: "v-collapse__content",
      style: _normalizeStyle(style.value)
    }, [
      _createElementVNode("div", {
        class: "v-collapse__inner",
        ref_key: "innerRef",
        ref: innerRef
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ], 4)
  ], 2))
}
}

})